export default "__VITE_ASSET__3c058858__"